export default "__VITE_ASSET__RX4xWI5p__"